import { useEffect, useState } from "react";
import { StudentMetricsModel } from "../../models/DashboardModel/StudentMetricsModel/studentMetrics.model";
import DashboardService from "../../services/DashboardService/dashboard.service";
import V2DashboardService from "../../services/v2/Institute/Admin/DashboardService/dashboard.service";
import { StudentActivitiesFilterModel } from "../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import { serialize } from "serializr";
import { number } from "yup";

interface StudentActivity {
  student_chapter_content: any;
  content_exercise_attempts: any;
  [key: string]: any;
}

export const useStudentActivities = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [videosLoading, setVideosLoading] = useState(true);
  const [exerciseLoading, setExerciseLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [quickQuizLoading, setQuickQuizLoading] = useState(true);
  const [metrics, setMetrics] = useState<StudentMetricsModel>({});
  const [activeCount, setActiveCount] = useState(0);
  const [loginCount, setLoginCount] = useState(0);
  const [notLoggedInCount, setNotLoggedInCount] = useState(0);
  const [signUpCount, setSignUpCount] = useState(0);
  const [pdfViewedCount, setPdfViewedCount] = useState(0);
  const [videoViewedCount, setVideoViewedCount] = useState(0);
  const [quickquizCount, setQuickquizCount] = useState(0);
  const [exerciseCount, setExerciseCount] = useState(0);
  const [loginStudents, setLoginStudents] = useState([]);
  const [classLoginsData, setClassLoginsData] = useState({logins: [], not_logins: [], login_sections_data: [], not_logged_in_sections_data:[]});
  const [branchLoginsData, setBranchLoginsData] = useState({logins: {}, active_count: {}, not_logins: {}});
  const [loginStudentsLoading, setLoginStudentsLoading] = useState(true);
  const [modalTitle, setModalTitle] = useState("");
  const [activities, setActivities] = useState<StudentActivity>();
  const [activitiesModalOpen, setActivitiesModalOpen] = useState(false);
  const [studentActivitiesLoading, setStudentActivitiesLoading] =
      useState(false);

  const payload = (filters: StudentActivitiesFilterModel) =>
    serialize(StudentActivitiesFilterModel, filters);

  const getActiveCount = (filters: StudentActivitiesFilterModel) => {
    setIsLoading(true);
    V2DashboardService.getActiveCount(
      payload(filters),
      setActiveCount,
      () => {},
      () => {
        setIsLoading(false);
      }
    );
  };

  const getLoginCount = (filters: StudentActivitiesFilterModel) => {
    setIsLoading(true);
    console.log(payload(filters), 'fileters', filters)
    V2DashboardService.getLoginsCount(
      payload(filters),
      setLoginCount,
      () => {},
      () => {
        setIsLoading(false);
      }
    );
  };

  const getNotLoggedInCount = (filters: StudentActivitiesFilterModel) => {
    setIsLoading(true);
    V2DashboardService.getNotLoggedInCount(
      payload(filters),
      setNotLoggedInCount,
      () => {},
      () => {
        setIsLoading(false);
      }
    );
  };

  const getSignUpCount = (filters: StudentActivitiesFilterModel) => {
    setIsLoading(true);
    V2DashboardService.getSignupsCount(
      payload(filters),
      setSignUpCount,
      () => {},
      () => {
        setIsLoading(false);
      }
    );
  };

  const getPDFViewed = (filters: StudentActivitiesFilterModel) => {
    setPdfLoading(true);
    V2DashboardService.getPDFViewed(
      payload(filters),
      setPdfViewedCount,
      () => {},
      () => {
        setPdfLoading(false);
      }
    );
  };

  const getVideoViewed = (filters: StudentActivitiesFilterModel) => {
    setVideosLoading(true);
    V2DashboardService.getVideoViewed(
      payload(filters),
      setVideoViewedCount,
      () => {},
      () => {
        setVideosLoading(false);
      }
    );
  };

  const getQuickQuicCount = (filters: StudentActivitiesFilterModel) => {
    setQuickQuizLoading(true);
    V2DashboardService.getQuickQuicCount(
      payload(filters),
      setQuickquizCount,
      () => {},
      () => {
        setQuickQuizLoading(false);
      }
    );
  };

  const getExerciseCount = (filters: StudentActivitiesFilterModel) => {
    setExerciseLoading(true);
    V2DashboardService.getExerciseCount(
      payload(filters),
      setExerciseCount,
      () => {},
      () => {
        setExerciseLoading(false);
      }
    );
  };

  const getNoOfLoggedInStudents = (filters) => {
    setLoginStudentsLoading(true);
    setModalTitle("Logged in Students");
    V2DashboardService.getNoOfLoggedInStudents(
      payload(filters),
      (students) => {
        setLoginStudents(students);
        setLoginStudentsLoading(false);
        setActivitiesModalOpen(true);
      },
      () => {},
      () => {}
    );
  };

  const getNotLoggedInStudents = (filters) => {
    setLoginStudentsLoading(true);
    setModalTitle("Not Logged In Students");
    V2DashboardService.getNotLoggedInStudents(
      payload(filters),
      (students) => {
        setLoginStudents(students);
        setLoginStudentsLoading(false);
        setActivitiesModalOpen(true);
      },
      () => {},
      () => {}
    );
  };

  const getActiveStudents = (filters) => {
    setLoginStudentsLoading(true);
    setModalTitle("Active Students");
    V2DashboardService.getActiveStudents(
      payload(filters),
      (students) => {
        setLoginStudents(students);
        setLoginStudentsLoading(false);
        setActivitiesModalOpen(true);
      },
      () => {},
      () => {}
    );
  };

  const getSignUpStudents = (filters) => {
    setLoginStudentsLoading(true);
    setModalTitle("Signups");
    V2DashboardService.getSignUps(
      payload(filters),
      (students) => {
        setLoginStudents(students);
        setLoginStudentsLoading(false);
        setActivitiesModalOpen(true);
      },
      () => {},
      () => {}
    );
  };

  const getClassLogins = (filters) => {
    V2DashboardService.getClassLogins(
      payload(filters),
      (data) => {
        setClassLoginsData(data);
      },
      () => {},
      () => {}
    );
  };

  const getBranchLogins = (filters) => {
    V2DashboardService.getBranchLogins(
      payload(filters),
      (data) => {
        setBranchLoginsData(data);
      },
      () => {},
      () => {}
    );
  };


  const fetchCompletedActivities = (id: number) => {
    setActivities(undefined);
    setStudentActivitiesLoading(true);
    V2DashboardService.fetchCompletedActivities(
      { id: id, ...payload },
      (students) => {
        setActivities(students);
        setStudentActivitiesLoading(false);
      },
      () => {},
      () => {}
    );
  };

  useEffect(() => {
    DashboardService.fetchStudentStatus(
      (data) => {
        setMetrics(data);
        setIsLoading(false);
      },
      () => {},
      () => {}
    );
  }, []);

  return {
    metrics,
    isLoading,
    videosLoading,
    exerciseLoading,
    quickQuizLoading,
    pdfLoading,
    activeCount,
    signUpCount,
    loginCount,
    notLoggedInCount,
    pdfViewedCount,
    videoViewedCount,
    quickquizCount,
    exerciseCount,
    loginStudents,
    loginStudentsLoading,
    modalTitle,
    activities,
    activitiesModalOpen,
    studentActivitiesLoading,
    classLoginsData,
    branchLoginsData,
    setIsLoading,
    getActiveCount,
    getLoginCount,
    getNotLoggedInCount,
    getSignUpCount,
    getPDFViewed,
    getVideoViewed,
    getQuickQuicCount,
    getExerciseCount,
    getNoOfLoggedInStudents,
    getNotLoggedInStudents,
    getActiveStudents,
    getSignUpStudents,
    fetchCompletedActivities,
    setActivitiesModalOpen,
    getClassLogins,
    getBranchLogins
  };
};
